import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';

type GetFilterConfigProps = {
  t: TFunction;
  canWrite: boolean;
};

export const getFilterConfig = ({ t, canWrite }: GetFilterConfigProps) => [
  {
    id: 'isDeleted',
    size: 2,
    type: FilterItemType.Select,
    props: {
      disableClearable: false,
      inputProps: {
        placeholder: t('common.status.label'),
        name: 'isDeleted',
        label: t('common.status.label'),
      },
      options: [
        {
          value: false,
          name: t('common.active'),
        },
        {
          value: true,
          name: t('common.inactive'),
        },
      ],
    },
  },
];
